import {computed} from "vue";

export default function useRestrictions(attributes) {

    const restrictions = computed(() => {
        return (
            Object.values(attributes)
                .filter(({ type }) => type.slug === "restrictions")
                .map(({ slug }) => slug)
        );
    });

    return {
        restrictions,
    }
}
